import { render, staticRenderFns } from "./UserScorableRangeUpload.vue?vue&type=template&id=041d5954&"
import script from "./UserScorableRangeUpload.vue?vue&type=script&lang=ts&"
export * from "./UserScorableRangeUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports